import React from 'react';

/**
 * PHLD — inline Heroicons (24/outline, MIT). Thin 1.5px stroke, currentColor.
 * Add more by copying paths from heroicons.com (24/outline).
 */
type IconProps = { size?: number; style?: React.CSSProperties };

const Icon = ({ path, size = 24, style }: IconProps & { path: React.ReactNode }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    width={size}
    height={size}
    style={style}
    aria-hidden="true"
  >
    {path}
  </svg>
);

export const ArrowLongRight = (p: IconProps) => <Icon {...p} path={<path d="M3 12h17m0 0l-5-5m5 5l-5 5" />} />;
export const ArrowUpRight = (p: IconProps) => <Icon {...p} path={<path d="M6 18L18 6m0 0H8m10 0v10" />} />;
export const Check = (p: IconProps) => <Icon {...p} path={<path d="M4.5 12.75l6 6 9-13.5" />} />;
export const CalendarDays = (p: IconProps) => (
  <Icon
    {...p}
    path={
      <>
        <path d="M6.75 3v2.25M17.25 3v2.25M3.75 8.25h16.5M4.5 5.25h15a.75.75 0 01.75.75v12.75a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5V6a.75.75 0 01.75-.75z" />
        <circle cx="8" cy="12.5" r="0.5" fill="currentColor" />
        <circle cx="12" cy="12.5" r="0.5" fill="currentColor" />
        <circle cx="16" cy="12.5" r="0.5" fill="currentColor" />
      </>
    }
  />
);
export const Microphone = (p: IconProps) => (
  <Icon {...p} path={<path d="M12 18.75a6 6 0 006-6v-1.5m-6 7.5a6 6 0 01-6-6v-1.5m6 7.5v3.75m-3.75 0h7.5M12 15.75a3 3 0 01-3-3V4.5a3 3 0 116 0v8.25a3 3 0 01-3 3z" />} />
);
export const Sparkle = (p: IconProps) => (
  <Icon {...p} path={<path d="M12 3v4.5M12 16.5V21M3 12h4.5M16.5 12H21M6.3 6.3l3.2 3.2M14.5 14.5l3.2 3.2M17.7 6.3l-3.2 3.2M9.5 14.5l-3.2 3.2" />} />
);
export const PenNib = (p: IconProps) => (
  <Icon {...p} path={<path d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931z" />} />
);
export const Clock = (p: IconProps) => (
  <Icon
    {...p}
    path={
      <>
        <circle cx="12" cy="12" r="8.25" />
        <path d="M12 7.5V12l3 1.75" />
      </>
    }
  />
);
export const Quote = (p: IconProps) => (
  <Icon {...p} path={<path d="M7 7h4v4c0 2.2-1.3 3.6-3.5 4M14 7h4v4c0 2.2-1.3 3.6-3.5 4" />} />
);
